/**
 * Get the API URL from runtime config or environment variables
 * @returns {string} The API base URL
 */
export const getApiUrl = () => {
    // In production (Docker), use runtime config injected by entrypoint script
    if (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.API_URL) {
        return window.RUNTIME_CONFIG.API_URL;
    }
    
    // In development, fall back to build-time environment variable
    if (process.env.REACT_APP_API_URI) {
        return process.env.REACT_APP_API_URI;
    }
    
    // Default fallback (should not normally be reached)
    console.warn('No API URL configured. Falling back to /api');
    return '/api';
};

/**
 * Get the server's timezone from runtime config or environment variables.
 * Falls back to the viewer's own zone when the container did not supply one.
 * @returns {string} An IANA timezone name
 */
export const getServerTimeZone = () => {
    if (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG.TIME_ZONE) {
        return window.RUNTIME_CONFIG.TIME_ZONE;
    }

    if (process.env.REACT_APP_TIME_ZONE) {
        return process.env.REACT_APP_TIME_ZONE;
    }

    console.warn('No server timezone configured. Timestamps will render in each viewer\'s own zone.');
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
